// @flow
import React from 'react'

import * as styles from './SiteFooter.module.css'

const currentYear = new Date().getFullYear()

const SiteFooter = ({isCalwep=false}) => (
  <footer className={`container block--md ${styles.footer}`}>
    {isCalwep && <span>For support, contact <a href='mailto:calwep@rachio.com'>calwep@rachio.com</a> or <a href='tel:9168667224'>+1 916-866-7224</a>.<br/></span>}
    Copyright &copy; {currentYear} Rachio, Inc. <br/>
    <a title="Privacy Policy (open in a new tab)" target="_blank" href="https://rachio.com/privacy-policy">Privacy Policy</a>
    <span>{" "}|{" "}</span>
    <a title="Privacy Policy California (open in a new tab)" target="_blank" href="https://rachio.com/privacy-policy-california">Privacy Policy California</a>
    <span>{" "}|{" "}</span>
    <a title="Terms of Use (open in a new tab)" target="_blank" href="https://rachio.com/terms-and-conditions">Terms of Use</a>
    <span>{" "}|{" "}</span>
    <a title="Do Not Sell My Personal Information (open in a new tab)" target="_blank" href="https://rachio.com/do-not-sell-my-personal-information">Do Not Sell My Personal Information</a>
  </footer>
)

export default SiteFooter
